import PropTypes from 'prop-types';
import { gridClasses } from '@mui/x-data-grid-pro';

import { SORT_OPTIONS } from 'constants/common';
import { DATA_GRID_PAGE_SIZE_OPTIONS } from 'constants/components';
import { DataGridTable } from 'components/complex/DataGridTable';

import { StickyBar } from '../StickyBar';

const styles = {
  inactiveRow: ({ palette }) => ({
    [`& .${gridClasses.row}.inactive-row`]: {
      backgroundColor: `${palette.colors.veryLightGrey} !important`,
    },
  }),
};

const getCellClassName = ({ field }) => (field === 'email' ? 'wrap-text-cell' : '');

const getRowClassName = ({ row }) => (row.is_active === false ? 'inactive-row' : '');

export const UsersDataGridTable = ({
  currentPage,
  pageSize,
  rowCount,
  onPageChange,
  onPageSizeChange,
  columns,
  rows,
  isRowSelectable,
  isFetchingUsersList,
  order,
  orderBy,
  onTableSort,
  selectedRows = [],
  setSelectedRows = () => {},
  isDisabledSelection,
  usersBarButtons = [],
  sortingMode = 'client',
  paginationMode = 'client',
  filterMode = 'client',
  filterModelItems = [],
  onFilterModelChange = () => {},
  isFilteredList = false,
  itemsName,
  checkboxSelection = true,
}) => {
  const sortModel = { field: orderBy, sort: order };

  return (
    <>
      <DataGridTable
        checkboxSelection={checkboxSelection}
        page={currentPage}
        pageSize={pageSize}
        rowCount={rowCount}
        columns={columns}
        rows={rows}
        isLoading={isFetchingUsersList}
        sortModel={sortModel}
        isDisabledSelection={isDisabledSelection}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        isRowSelectable={isRowSelectable}
        onTableSort={onTableSort}
        rowsPerPageOptions={DATA_GRID_PAGE_SIZE_OPTIONS.USERS}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        customStyles={{ dataGrid: styles.inactiveRow }}
        getCellClassName={getCellClassName}
        getRowClassName={getRowClassName}
        sortingMode={sortingMode}
        paginationMode={paginationMode}
        filterMode={filterMode}
        filterModelItems={filterModelItems}
        onFilterModelChange={onFilterModelChange}
        isFilteredList={isFilteredList}
        itemsName={itemsName}
      />

      <StickyBar
        selectedItemsCount={selectedRows.length}
        buttons={usersBarButtons}
        onCloseBar={() => setSelectedRows([])}
      />
    </>
  );
};

const barButtonPropTypes = {
  Icon: PropTypes.func,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

UsersDataGridTable.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetchingUsersList: PropTypes.bool.isRequired,
  order: PropTypes.oneOf(Object.values(SORT_OPTIONS)).isRequired,
  orderBy: PropTypes.string.isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  isDisabledSelection: PropTypes.bool.isRequired,
  usersBarButtons: PropTypes.arrayOf(
    PropTypes.shape({
      ...barButtonPropTypes,
      subItems: PropTypes.arrayOf(PropTypes.shape(barButtonPropTypes)),
    }),
  ),
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  isRowSelectable: PropTypes.func.isRequired,
  onTableSort: PropTypes.func.isRequired,
  setSelectedRows: PropTypes.func,
  sortingMode: PropTypes.oneOf(['client', 'server']),
  paginationMode: PropTypes.oneOf(['client', 'server']),
  filterMode: PropTypes.oneOf(['client', 'server']),
  filterModelItems: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    }),
  ),
  onFilterModelChange: PropTypes.func,
  isFilteredList: PropTypes.bool,
  itemsName: PropTypes.string.isRequired,
  checkboxSelection: PropTypes.bool,
};
